import React from 'react';
import Avatar from 'components-v3/Avatar/Avatar.jsx';

const UserInfo = ({ user, attribute }) => {
  return (
    <div style={styles.userInfoContainer}>
      <Avatar
        title={user.displayName}
        colorSetId={user.colorSetId}
        imageUrl={user?.avatar?.url}
        numberOfInitials={2}
        size="small"
      />
      <div style={styles.userInfo}>
        <div>{user.displayName}</div>
        <div style={styles.attribute}>{user[attribute] || ''}</div>
      </div>
    </div>
  );
};

const styles = {
  userInfoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 12,
  },
  attribute: {
    color: '#9F9F9F',
  },
};

export default UserInfo;
